import React, { useContext } from "react"
import styled from "styled-components"
import GameContext from "../../../Context/GameContext"
import { useAllowPreviews } from "../../shared/hooks/useAllowPreviews"
import { Circle } from "rc-progress"
import { calcPercentAndColor } from "../../shared/player/calcPercentAndColor"
import { ResourceValue } from "./ResourceValue"
import getMediaUrl from "../../../utils/mediaUrl"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  border: 1px solid ${props => props.theme.colors?.host_player_border};
  border-radius: 5px;
  padding: 10px 5px 5px 5px;
  align-items: center;
  background-color: ${props => props.theme.colors?.host_player_background};
`

const ResourceWrap = styled.div`
  display: flex;
  align-items: center;
`
const AvatarWrap = styled.div``

export const PlayerEnergy = ({ player, isHost }) => {
  const { gameProps } = useContext(GameContext)
  const color = player?.role?.color
  const current = player?.energy?.current || 0
  const preview = player?.energy?.preview || 0
  const allowPreview = useAllowPreviews()
  const showPreview = current !== preview && allowPreview

  const name = player?.name || ""
  const imageUrl = getMediaUrl(gameProps.strapiUrl, player?.role?.avatar?.url)
  const imageAlt = player?.role?.avatar?.alternativeText

  const { percent, strokeColor } = calcPercentAndColor(
    current,
    preview,
    showPreview,
    color
  )

  return (
    <Wrap title={name}>
      <ResourceWrap>
        <ResourceValue player={player} />
      </ResourceWrap>
      <AvatarWrap>
        <Circle
          gapDegree={0}
          gapPosition="top"
          percent={percent}
          strokeWidth={7}
          strokeLinecap="round"
          strokeColor={strokeColor}
          trailColor={"rgba(0,0,0,0)"}
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPositionY: 0,
            backgroundPositionX: "50%",
            borderRadius: "50%",
            boxShadow: "inset 0px 0 10px white",
            height: isHost ? 100 : 80,
          }}
        />
        {imageAlt && <span role="img" aria-label={imageAlt}></span>}
      </AvatarWrap>
    </Wrap>
  )
}
